import ReduxModel from 'shared/lib/orm/reduxModel'

const Model = {}

Model.Cart = ReduxModel('Cart', {
  defaultValues: {},
  hasMany: {
    lines: { namespace: Model }
  },
  hasOne: {
    coupon: { namespace: Model }
  }
})

Model.Line = ReduxModel('Line', {
  defaultValues: {},
  belongsTo: {
    cart: { namespace: Model }
  }
})

Model.ProductGroup = ReduxModel('ProductGroup', {
  defaultValues: {},
  hasMany: {
    products: { foreignKey: 'product_group_id', namespace: Model },
    album_photos: { namespace: Model, modelName: 'Photo' }

  },
  hasOne: {
    photo: { namespace: Model }
  }
})

Model.Product = ReduxModel('Product', {
  defaultValues: {},
  belongsTo: {
    product_group: { namespace: Model }
  }
})

Model.Item = ReduxModel('Item', {
  apiVersion: 3
})

Model.Bundle = ReduxModel('Bundle', {
  apiVersion: 3
})

Model.BundleItem = ReduxModel('BundleItem', {
  apiVersion: 3
})

Model.Location = ReduxModel('Location', {
  apiVersion: 3
})

Model.Availability = ReduxModel('ShopAvailability')

Model.OperatingDateTime = ReduxModel('OperatingDateTime')

Model.OperatingRule = ReduxModel('OperatingRule')

Model.Photo = ReduxModel('Photo')

Model.Collection = ReduxModel('Collection')

Model.Coupon = ReduxModel('Coupon')

export default Model
